import React from "react";
import { animate, delay, motion } from "framer-motion";

// components
import HeroImage from "./HeroImage";
import HeroTypewriter from "./HeroTypewriter";
import Disclaimers from "../Globals/Disclaimers";

const heroTypewriterVariants = {
	initial: {
		opacity: 0,
		x: 100,
	},
	animate: {
		opacity: 1,
		x: 0,
	},
	exit: {
		opacity: 0,
		x: 100,
	},
	transition: {
		duration: 0.5,
		delay: 0.5,
		type: "spring",
		damping: 10,
		mass: 1,
		stiffness: 30,
	},
};

const waveHandVariants = {
	animate: {
		rotate: 180,
	},
	transition: { repeat: Infinity },
};

const Hero = () => {
	return (
		<section className="py-2 flex flex-col lg:flex-row justify-center items-center gap-2">
			<HeroImage />
			<motion.div
				variants={heroTypewriterVariants}
				{...heroTypewriterVariants}
				className="flex flex-col gap-2 text-center p-5">
				<h1 className="text-2xl lg:text-5xl text-green-800">
					Hello, I'm Ivanvielle
				</h1>
				<HeroTypewriter />
				<Disclaimers />
			</motion.div>
		</section>
	);
};

export default Hero;
